import { normalize, mapObjectToList } from '../utils';
import { merge } from 'lodash';

const initialState = {
  loading: false,
  loaded: false,
  errors: {},
  data: {},
};

const surfaceTypes = (state = initialState, { type, payload }) => {
  switch (type) {
    case 'SURFACE_TYPE_LIST_REQUEST':
      return {
        ...state,
        loading: true,
      };
    case 'SURFACE_TYPE_LIST_SUCCESS':
      return {
        ...state,
        loading: false,
        loaded: true,
        data: Object.assign({}, state.data, normalize(payload)),
      };
    case 'SURFACE_TYPE_LIST_FAILURE':
      return {
        ...state,
        loading: false,
        errors: payload.errors,
      };
    case 'ESTIMATOR_LIST_SUCCESS':
    case 'ESTIMATOR_RESOURCE_SUCCESS':
    case 'INSTALLER_RESOURCE_SUCCESS': {
      const st = payload.entities && payload.entities.surface_types;
      return merge({}, state, { data: st });
    }
    default:
      return state;
  }
};

export default surfaceTypes;

export const surfaceTypeList = state => mapObjectToList(state.data);
export const getById = state => id => state.data[id];



// WEBPACK FOOTER //
// ./client/app/reducers/surfaceTypes.js